import { render, staticRenderFns } from "./UpgradeTeamPlanBanner.vue?vue&type=template&id=2e8c068d&"
import script from "./UpgradeTeamPlanBanner.vue?vue&type=script&lang=js&"
export * from "./UpgradeTeamPlanBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports